var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommPrefPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.697,
    height: 78.5,
    viewBox: "0 0 61.697 78.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-1006.939 -2384.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(1006.939 2384.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1.505 1.505)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 46.948,
    height: 75.49,
    rx: 11,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(40.95 1.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1174.318,2390.719h-4.107v75.49h4.107a3.4,3.4,0,0,0,3.4-3.4v-68.7A3.4,3.4,0,0,0,1174.318,2390.719Z",
    transform: "translate(-1170.211 -2390.719)",
    fill: "#d3e6f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1.505 70.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1016.335,2672.475h40.155a3.4,3.4,0,0,0,3.4-3.4v-3.042h-46.948v3.042A3.4,3.4,0,0,0,1016.335,2672.475Z",
    transform: "translate(-1012.939 -2666.036)",
    fill: "#fd919e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(40.95 70.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1170.211,2672.475h4.107a3.4,3.4,0,0,0,3.4-3.4v-3.042h-7.5Z",
    transform: "translate(-1170.211 -2666.036)",
    fill: "#e8677d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(14.619 1.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1080.952,2398.639h-10.735a3.507,3.507,0,0,1-3.358-2.5l-1.635-5.425h20.72l-1.635,5.425A3.507,3.507,0,0,1,1080.952,2398.639Z",
    transform: "translate(-1065.225 -2390.719)",
    fill: "#fd919e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1051.995,2463.218H1011.84a4.906,4.906,0,0,1-4.9-4.9v-68.7a4.907,4.907,0,0,1,4.9-4.9h40.155a4.907,4.907,0,0,1,4.9,4.9v68.7A4.906,4.906,0,0,1,1051.995,2463.218Zm-40.155-75.49a1.893,1.893,0,0,0-1.891,1.892v68.7a1.893,1.893,0,0,0,1.891,1.891h40.155a1.893,1.893,0,0,0,1.892-1.891v-68.7a1.894,1.894,0,0,0-1.892-1.892Z",
    transform: "translate(-1006.939 -2384.719)",
    fill: "#2a3953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(13.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1076.457,2395.649h-10.734a4.982,4.982,0,0,1-4.8-3.566l-1.635-5.425a1.505,1.505,0,0,1,1.441-1.939h20.72a1.505,1.505,0,0,1,1.441,1.939l-1.635,5.425A4.983,4.983,0,0,1,1076.457,2395.649Zm-13.7-7.921,1.051,3.486a1.991,1.991,0,0,0,1.917,1.425h10.734a1.991,1.991,0,0,0,1.918-1.425l1.05-3.486Z",
    transform: "translate(-1059.224 -2384.719)",
    fill: "#2a3953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 69.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1051.995,2669.484H1011.84a4.907,4.907,0,0,1-4.9-4.9v-3.042a1.5,1.5,0,0,1,1.505-1.5h46.948a1.5,1.5,0,0,1,1.5,1.5v3.042A4.907,4.907,0,0,1,1051.995,2669.484Zm-42.046-6.438v1.538a1.894,1.894,0,0,0,1.891,1.891h40.155a1.894,1.894,0,0,0,1.892-1.891v-1.538Z",
    transform: "translate(-1006.939 -2660.036)",
    fill: "#2a3953"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(1012.059 2389.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(1.505 13.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    d: "M9.924,0h16.9a0,0,0,0,1,0,0V19.847a0,0,0,0,1,0,0H9.924A9.924,9.924,0,0,1,0,9.924v0A9.924,9.924,0,0,1,9.924,0Z",
    fill: "#d3e6f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(28.331 1.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1159.766,2453.906l-19.455-12.286v-19.848l19.455-12.285Z",
    transform: "translate(-1140.311 -2409.488)",
    fill: "#d3e6f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(39.624 1.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1185.339,2414.642v34.11l8.162,5.154v-44.418Z",
    transform: "translate(-1185.339 -2409.488)",
    fill: "#a4cff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(47.786 18.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    d: "M4.962,0H7.286a0,0,0,0,1,0,0V9.924a0,0,0,0,1,0,0H4.962A4.962,4.962,0,0,1,0,4.962v0A4.962,4.962,0,0,1,4.962,0Z",
    transform: "translate(7.286 9.924) rotate(180)",
    fill: "#7babf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(16.166 33.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1095.5,2562.454h0a3.693,3.693,0,0,1-3.693-3.693V2537.6h7.386v21.157A3.693,3.693,0,0,1,1095.5,2562.454Z",
    transform: "translate(-1091.807 -2537.604)",
    fill: "#7babf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 12.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1055.683,2475.327h-16.9a11.428,11.428,0,0,1,0-22.857h16.9a1.5,1.5,0,0,1,1.505,1.5v19.847A1.505,1.505,0,0,1,1055.683,2475.327Zm-16.9-19.847a8.419,8.419,0,0,0,0,16.838h15.4V2455.48Z",
    transform: "translate(-1027.352 -2452.47)",
    fill: "#2a3953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(46.281 17.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1215.709,2485.187h-2.325a1.5,1.5,0,0,1-1.5-1.5v-9.924a1.5,1.5,0,0,1,1.5-1.5h2.325a6.467,6.467,0,0,1,0,12.934Zm-.82-3.01h.82a3.457,3.457,0,0,0,0-6.915h-.82Z",
    transform: "translate(-1211.88 -2472.254)",
    fill: "#2a3953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(26.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1155.271,2450.916a1.5,1.5,0,0,1-.8-.233l-19.455-12.284a1.506,1.506,0,0,1-.7-1.273v-19.847a1.5,1.5,0,0,1,.7-1.272l19.455-12.286a1.505,1.505,0,0,1,2.308,1.273v44.417a1.5,1.5,0,0,1-1.505,1.5Zm-17.95-14.62,16.445,10.385v-38.957l-16.445,10.383Z",
    transform: "translate(-1134.311 -2403.489)",
    fill: "#2a3953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(14.661 32.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1091,2559.464a5.2,5.2,0,0,1-5.2-5.2v-21.157a1.505,1.505,0,0,1,1.5-1.5h7.386a1.505,1.505,0,0,1,1.505,1.5v21.157A5.2,5.2,0,0,1,1091,2559.464Zm-2.188-24.85v19.652a2.188,2.188,0,0,0,4.376,0v-19.652Z",
    transform: "translate(-1085.807 -2531.604)",
    fill: "#2a3953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(38.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1189,2450.916a1.5,1.5,0,0,1-.8-.233l-8.162-5.153a1.5,1.5,0,0,1-.7-1.272v-34.11a1.505,1.505,0,0,1,.7-1.272l8.162-5.154a1.505,1.505,0,0,1,2.308,1.273v44.417a1.5,1.5,0,0,1-1.5,1.5Zm-6.657-7.488,5.152,3.253v-38.957l-5.152,3.252Z",
    transform: "translate(-1179.338 -2403.489)",
    fill: "#2a3953"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommPrefPhoneIcon);
export default __webpack_public_path__ + "static/media/comm-pref-phone-icon.9bc3e38bd2e8ce22b00a7f044c444a8a.svg";
export { ForwardRef as ReactComponent };